/* tslint:disable */
/* eslint-disable */
/**
 * Umsatzcontrolling
 * Money
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { RailiumEinsatzHistorie } from './RailiumEinsatzHistorie';
import {
    RailiumEinsatzHistorieFromJSON,
    RailiumEinsatzHistorieFromJSONTyped,
    RailiumEinsatzHistorieToJSON,
} from './RailiumEinsatzHistorie';

/**
 * 
 * @export
 * @interface UmsatzHistorie
 */
export interface UmsatzHistorie {
    /**
     * 
     * @type {number}
     * @memberof UmsatzHistorie
     */
    umsatzId: number;
    /**
     * 
     * @type {number}
     * @memberof UmsatzHistorie
     */
    umsatzHistorieId: number;
    /**
     * Falls dieses UmsatzHistorie-Objekt zur Laufzeit durch einen Zeitintervall-Split synthetisch erzeugt wurde, enthält dieses Feld die ID des ursprünglichen UmsatzHistorie-Objekts.
     * @type {number}
     * @memberof UmsatzHistorie
     */
    basisUmsatzHistorieId?: number;
    /**
     * 
     * @type {Array<RailiumEinsatzHistorie>}
     * @memberof UmsatzHistorie
     */
    historieRailiumEinsaetze?: Array<RailiumEinsatzHistorie>;
    /**
     * 
     * @type {string}
     * @memberof UmsatzHistorie
     */
    gueltigVon: string;
    /**
     * 
     * @type {string}
     * @memberof UmsatzHistorie
     */
    gueltigBis: string;
    /**
     * 
     * @type {string}
     * @memberof UmsatzHistorie
     */
    erstelltVon: string;
    /**
     * 
     * @type {string}
     * @memberof UmsatzHistorie
     */
    geloeschtVon?: string;
    /**
     * 
     * @type {string}
     * @memberof UmsatzHistorie
     */
    aenderungsGrund?: string;
    /**
     * 
     * @type {string}
     * @memberof UmsatzHistorie
     */
    datum: string;
    /**
     * 
     * @type {number}
     * @memberof UmsatzHistorie
     */
    betragUeberschrieben?: number;
    /**
     * 
     * @type {number}
     * @memberof UmsatzHistorie
     */
    betragEndergebnis: number;
    /**
     * 
     * @type {string}
     * @memberof UmsatzHistorie
     */
    prognoseStatus: string;
    /**
     * 
     * @type {string}
     * @memberof UmsatzHistorie
     */
    prognoseStatusInformation?: string;
    /**
     * 
     * @type {string}
     * @memberof UmsatzHistorie
     */
    prognoseGruppenTyp: string;
    /**
     * 
     * @type {boolean}
     * @memberof UmsatzHistorie
     */
    manuellAbgeschlossen: boolean;
    /**
     * 
     * @type {number}
     * @memberof UmsatzHistorie
     */
    betragEndergebnisDifferenz?: number;
    /**
     * 
     * @type {number}
     * @memberof UmsatzHistorie
     */
    betragUeberschriebenDifferenz?: number;
}

/**
 * Check if a given object implements the UmsatzHistorie interface.
 */
export function instanceOfUmsatzHistorie(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "umsatzId" in value;
    isInstance = isInstance && "umsatzHistorieId" in value;
    isInstance = isInstance && "gueltigVon" in value;
    isInstance = isInstance && "gueltigBis" in value;
    isInstance = isInstance && "erstelltVon" in value;
    isInstance = isInstance && "datum" in value;
    isInstance = isInstance && "betragEndergebnis" in value;
    isInstance = isInstance && "prognoseStatus" in value;
    isInstance = isInstance && "prognoseGruppenTyp" in value;
    isInstance = isInstance && "manuellAbgeschlossen" in value;

    return isInstance;
}

export function UmsatzHistorieFromJSON(json: any): UmsatzHistorie {
    return UmsatzHistorieFromJSONTyped(json, false);
}

export function UmsatzHistorieFromJSONTyped(json: any, ignoreDiscriminator: boolean): UmsatzHistorie {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'umsatzId': json['umsatzId'],
        'umsatzHistorieId': json['umsatzHistorieId'],
        'basisUmsatzHistorieId': !exists(json, 'basisUmsatzHistorieId') ? undefined : json['basisUmsatzHistorieId'],
        'historieRailiumEinsaetze': !exists(json, 'historieRailiumEinsaetze') ? undefined : ((json['historieRailiumEinsaetze'] as Array<any>).map(RailiumEinsatzHistorieFromJSON)),
        'gueltigVon': json['gueltigVon'],
        'gueltigBis': json['gueltigBis'],
        'erstelltVon': json['erstelltVon'],
        'geloeschtVon': !exists(json, 'geloeschtVon') ? undefined : json['geloeschtVon'],
        'aenderungsGrund': !exists(json, 'aenderungsGrund') ? undefined : json['aenderungsGrund'],
        'datum': json['datum'],
        'betragUeberschrieben': !exists(json, 'betragUeberschrieben') ? undefined : json['betragUeberschrieben'],
        'betragEndergebnis': json['betragEndergebnis'],
        'prognoseStatus': json['prognoseStatus'],
        'prognoseStatusInformation': !exists(json, 'prognoseStatusInformation') ? undefined : json['prognoseStatusInformation'],
        'prognoseGruppenTyp': json['prognoseGruppenTyp'],
        'manuellAbgeschlossen': json['manuellAbgeschlossen'],
        'betragEndergebnisDifferenz': !exists(json, 'betragEndergebnisDifferenz') ? undefined : json['betragEndergebnisDifferenz'],
        'betragUeberschriebenDifferenz': !exists(json, 'betragUeberschriebenDifferenz') ? undefined : json['betragUeberschriebenDifferenz'],
    };
}

export function UmsatzHistorieToJSON(value?: UmsatzHistorie | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'umsatzId': value.umsatzId,
        'umsatzHistorieId': value.umsatzHistorieId,
        'basisUmsatzHistorieId': value.basisUmsatzHistorieId,
        'historieRailiumEinsaetze': value.historieRailiumEinsaetze === undefined ? undefined : ((value.historieRailiumEinsaetze as Array<any>).map(RailiumEinsatzHistorieToJSON)),
        'gueltigVon': value.gueltigVon,
        'gueltigBis': value.gueltigBis,
        'erstelltVon': value.erstelltVon,
        'geloeschtVon': value.geloeschtVon,
        'aenderungsGrund': value.aenderungsGrund,
        'datum': value.datum,
        'betragUeberschrieben': value.betragUeberschrieben,
        'betragEndergebnis': value.betragEndergebnis,
        'prognoseStatus': value.prognoseStatus,
        'prognoseStatusInformation': value.prognoseStatusInformation,
        'prognoseGruppenTyp': value.prognoseGruppenTyp,
        'manuellAbgeschlossen': value.manuellAbgeschlossen,
        'betragEndergebnisDifferenz': value.betragEndergebnisDifferenz,
        'betragUeberschriebenDifferenz': value.betragUeberschriebenDifferenz,
    };
}

